import { ComponentInterface } from '@fusioncharts/core/src/component-interface';
import { getMouseCoordinate } from '@fusioncharts/core/src/lib';

let dragstart = function (dragTracker) {
    return function (oriEvent) {
      let chart = dragTracker.getFromEnv('chart'),
        config = dragTracker.config,
        datasets = chart.config.datasetOrder || chart.getDatasets(),
        coordinate = getMouseCoordinate(chart.getFromEnv('chart-container'), oriEvent, chart),
        pointFound,
        hoveredInfo,
        i = datasets.length,
        dataset;

      while (i-- && !pointFound) {
        dataset = datasets[i];
        if (dataset && dataset.getState('visible')) {
          hoveredInfo = dataset._getHoveredPlot && dataset._getHoveredPlot(coordinate.chartX, coordinate.chartY);
          if (hoveredInfo && hoveredInfo.hovered) {
            pointFound = true;
            config.dragStart = true;
            config.hoveredInfo = hoveredInfo;
            config.hoveredDS = dataset;
            dataset.drag('dragstart', oriEvent, hoveredInfo.pointIndex, coordinate);
          }
        }
      }
    };
  },
  dragmove = function (dragTracker) {
    return function (oriEvent) {
      let config = dragTracker.config;
      config.dragStart && config.hoveredDS.drag('dragmove', oriEvent, config.hoveredInfo.pointIndex);
    };
  },
  dragend = function (dragTracker) {
    return function (oriEvent) {
      let config = dragTracker.config;
      config.dragStart && config.hoveredDS.drag('dragend', oriEvent, config.hoveredInfo.pointIndex);
      config.dragStart = false;
    };
  },
  eventList = ['fc-dragstart', 'fc-dragmove', 'fc-dragend'];

/**
 * This class manages the drag-interaction over draggable charts
 */
class DragTracker extends ComponentInterface {
  constructor () {
    super();
    this.config.eventCb = {
      'fc-dragstart': dragstart(this),
      'fc-dragmove': dragmove(this),
      'fc-dragend': dragend(this)
    };
  }

  /**
   * Function to add events on the canvas for drag
   */
  addEvents () {
    var dragTracker = this,
      allCanvas = dragTracker.getFromEnv('chart').getChildren('canvas'); // eslint-disable-line good-practices/no-single-usage-variable
    dragTracker.removeEvents();
    allCanvas.forEach(canvas => {
      eventList.forEach(events => {
        canvas.addEventListener(events, dragTracker.config.eventCb[events]);
      });
    });
  }

  /**
   * Function to remove drag events on the canvas
   */
  removeEvents () {
    var dragTracker = this,
      allCanvas = dragTracker.getFromEnv('chart').getChildren('canvas'); // eslint-disable-line good-practices/no-single-usage-variable

    allCanvas.forEach(canvas => {
      eventList.forEach(events => {
        canvas.removeEventListener(events, dragTracker.config.eventCb[events]);
      });
    });
  }

  /**
   * This method is used to remove all event listeners attached by MouseTracker to the chart.
   */
  _dispose () {
    this.removeEvents();
    super._dispose();
  }
}

export default DragTracker;
